import { Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-card-locked-overlay',
  templateUrl: './card-locked-overlay.component.html',
  styleUrls: ['./card-locked-overlay.component.scss']
})
export class CardLockedOverlayComponent {
  @Input() lockedText: string;

  constructor() { }

}



// WEBPACK FOOTER //
// ./ts/app/shared/card-locked-overlay/card-locked-overlay.component.ts